import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { CFormInput, CFormCheck, CButton, CRow, CCol, CFormLabel, CCardText, CFormTextarea, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter } from '@coreui/react'
import FacilityCRUD from '../../services/general/getFacilityData.api'
import PatientSuperBillData from '../../services/general/patientSuperBill.api'
import { toastConfig } from '../../constants/other.config'
import toast from 'react-hot-toast'
import { Info } from 'lucide-react'
import SaveExtra from '../../services/general/saveExtraData.api'
import PatientAppointmentDetails from '../../services/general/appointmentData.api'
import { useIndexedDB } from '../../context/IndexedContext'

const ProviderSuperbill = ({ viewPatientDetail, patientTreatments,getSuperbillForthisnote,getAppointmentForThisPatientScheduled, noteID, setIsSuperbillUpdateOrSubmitted, patientDiagnosis, diagnosisCode, showInModel = false, setShowSuperBill , patientDBData , setPatientDBData ,noteCallType, superBillState,signedButtonStatus, setSignedButtonStatus,setPatientModalVisible, setFilteredPatientData , setShowOrderModel }) => {
  console.log('viewPatientDetail', viewPatientDetail, patientDiagnosis, diagnosisCode , patientDBData , superBillState)

  
  const [allAppointmentRawData, setAllAppointmentRawData] = useState([])

  const [formData, setFormData] = useState({
    PDate: '19/06/2025',
    facilityName: viewPatientDetail?.FacilityName || 'Solaris Healthcare Zephyrhills (ACC North)',
    facilityType: 'SNF',
    patientType: null,
    followUpTime: '1 week',
    cptCode: null,
    icdCodes: '',
    modifier: null,
    checkedOut: false,
    reason: '',
    patientSeen: true,
    notSeenReason: '',
    customReason: '',
    extraModifierOtherValue: '',
  })



  

  console.log('allAppointmentRawData', allAppointmentRawData,formData)

  const noteType = 'New note'

  const [facilityType, setFacilityType] = useState('')
  const [superBill, setSuperBill] = useState([])
  const [allAppointments, setAllAppointments] = useState([])
  const [visible, setVisible] = useState(false)
  const [errors, setErrors] = useState({})



    const { getFacilityData, getAllAppointmentData, getOfflineData, getProviderList, getProviderDetails, saveOfflineData , getOpenChartOfflineData , saveOpenChartOfflineData  , saveOpenChartAppointmentData , saveAllTodaysAppointment , getAllTodaysAppointment , getOpenChartAppointmentData , getPreSignedData , savePreSignedData , getPreSignedAppointment , savePreSignedAppointment} = useIndexedDB()
 
  const isMoreThanOneWeek = (() => {
    if (!formData.followUpTime) return false
    const numberOfWeeks = parseInt(formData.followUpTime)
    return numberOfWeeks > 1
  })()

 

  useEffect(() => {
    const getap = async () => {
      // const result = await PatientAppointmentDetails("GET", '', "", '', '')
      const result = await getAllAppointmentData()
      // const result = await SaveExtra('Get_By_Type', 'multiAppointmentsData', '', '')
      const rawData = JSON.parse(result.d)?.Data || []
      console.log('data ,rawdata ', rawData)
      setAllAppointmentRawData(
        rawData.map((item) => {
          return {
            ...item,
            AppointmentDetails: JSON.parse(item?.AppointmentDetails),
          }
        })
      )

      let structuredData = []

      rawData.forEach((item) => {
        let parsedList = JSON.parse(item?.AppointmentDetails)

        if (Array.isArray(parsedList)) {
          parsedList.forEach((parsedItem) => {
            const patientID = parsedItem?.patientID
            const appointmentDetails = parsedItem?.appointmentDetails || []

            const formattedAppointments = appointmentDetails.map((appointment) => {
              const data = appointment?.data || {}
              const current = appointment?.current || {
                Patient: { value: data?.PatientID || '', label: data?.AppointmentName || 'Unknown' },
                Provider: { value: '', label: data?.ProviderName || 'Unknown' },
                Facility: { value: '', label: data?.Facility || 'Unknown' },
                Insurance: data?.Insurance || {},
                otherDetails: data?.otherDetails || {},
              }

              return { data, current, appointmentId: item.ID }
            })

            structuredData.push({
              patientID,
              appointmentId: item.ID,
              appointmentDetails: formattedAppointments,
            })
          })
        } else {
          console.warn('Unexpected non-array parsed data:', parsedList)
        }
      })

      console.log('structure data ', structuredData)
      setAllAppointments(structuredData)
    }
    getap()
  }, [])

  const handleSubmitAp = async (updateData, type = null) => {
    try {
      const groupedData = []

      updateData.forEach((entry) => {
        const patientID = entry.current.Patient.value

        const existing = groupedData.find((item) => item.patientID === patientID)

        if (existing) {
          existing.appointmentDetails.push({ data: entry.data, current: entry.current })
        } else {
          groupedData.push({
            patientID,
            appointmentDetails: [{ data: entry.data, current: entry.current }],
          })
        }
      })

      console.log('appointment data  -------->', groupedData)
      await SaveExtra('Update', 'multiAppointmentsData', JSON.stringify(groupedData), allAppointment[0]?.Id || 388)

      // getAppointmentData();
      getData()
      if (type === 'save') {
        // toast.success('Saved Successfully', toastConfig);
      } else if (type === 'create') {
        toast.success('Created Successfully', toastConfig)
      }
    } catch (error) {
      toast.error('Failed to save', toastConfig)
    } finally {
    }
  }

  const updatePatientType = async (patientID, ID, ScheduleDate, ProviderID, AppointmentDetails, CreatedDate) => {
    const data = await getPreSignedData()
    const loggedUser = await getProviderDetails()
    const loggedUserID = loggedUser?.ID
    const userData = { ...(data[loggedUserID] || {}) }
    const patientData = { ...(userData[patientID] || {}) }
    const newlyAddedData = patientData.newlyAddedData || []

    console.log('orderAllDetials', newlyAddedData)
   
    const updateApType = {
      Mode: 'UPDATE',
      ID,
      ScheduleDate,
      ProviderID,
      AppointmentDetails,
      CreatedDate,
    }
    const updatedPatientData = {
      ...patientData,
      updateAppointmentType: [updateApType],
      newlyAddedData: { ...newlyAddedData, updateAppointmentType: [updateApType] },
    }

    const updatedUserData = {
      ...userData,
      [patientID]: updatedPatientData,
    }

    const updatedData = {
      ...data,
      [loggedUserID]: updatedUserData,
    }

    console.log('updatedDataSB', updatedData , noteCallType)
 
    // console.log('ordeer update in ls ', updatedData)
       savePreSignedData(updatedData)

      setPatientDBData(updatedPatientData)
  }


  const updateScheduleDataWithPatientSeenType = async () => {
    if (!viewPatientDetail?.PatientID || allAppointments.length === 0) return

    console.log(allAppointments, 'allAppointments', viewPatientDetail)

    const matchAppointment = allAppointments.find((appt) => appt.patientID === viewPatientDetail.PatientID)
    console.log(matchAppointment, 'matchAppointment')

    if (!matchAppointment) return

    const allMatchedAppointmentAppointmentDetails = matchAppointment?.appointmentDetails || []

    console.log(allMatchedAppointmentAppointmentDetails, 'allMatchedAppointmentAppointmentDetails')

    if (allMatchedAppointmentAppointmentDetails.length === 0) return

    const AppointmentToUpdate = allMatchedAppointmentAppointmentDetails.find((item) => item?.data?.Status === 'Scheduled' || item?.data?.Status === 'Rescheduled')


    if (!AppointmentToUpdate) return

    console.log('AppointmentToUpdate', AppointmentToUpdate)

    const updatedData = {
      ...AppointmentToUpdate,
      data: {
        ...AppointmentToUpdate?.data,
        // Status:"Rescheduled",
        patientSeen: formData.patientSeen,
        notSeenReason: formData?.notSeenReason,
        customReason: formData?.customReason || '',
        term: formData?.patientType,
      },
    }

    console.log(updatedData, 'updatedData')
    console.log(allMatchedAppointmentAppointmentDetails, 'allMatchedAppointmentAppointmentDetails')

    const updatedAllMatchedAppointmentDetails = allMatchedAppointmentAppointmentDetails.map((item) => {
      if (item?.data?.Status === 'Scheduled' || item?.data?.Status === 'Rescheduled') {
        return updatedData
      }
      return item
    })

    console.log(updatedAllMatchedAppointmentDetails, 'updatedAllMatchedAppointmentDetails')

    const updatedMatched = {
      ...matchAppointment,
      appointmentDetails: updatedAllMatchedAppointmentDetails,
    }

    console.log(updatedMatched, 'updatedMatched')

    console.log(AppointmentToUpdate, 'AppointmentToUpdates')

    const findAppointmentInRawData = allAppointmentRawData.find(item => item.ID === AppointmentToUpdate?.appointmentId)

    if (!findAppointmentInRawData) return

    console.log(findAppointmentInRawData, 'findAppointmentInRawData')
    const findPatientAppointments = findAppointmentInRawData?.AppointmentDetails?.map((item) => {
      if (item?.patientID === viewPatientDetail.PatientID) {
        return updatedMatched
      }
      return item
    })

    if (findPatientAppointments.length > 0) {
      console.log('running updating the appointment detail')
      await updatePatientType(viewPatientDetail.PatientID , findAppointmentInRawData.ID, findAppointmentInRawData.ScheduleDate, findAppointmentInRawData.ProviderID, JSON.stringify(findPatientAppointments), findAppointmentInRawData.CreatedDate)
      //  await PatientAppointmentDetails("UPDATE", findAppointmentInRawData.ID, findAppointmentInRawData.ScheduleDate, findAppointmentInRawData.ProviderID, JSON.stringify(findPatientAppointments), findAppointmentInRawData.CreatedDate);
    }
  }

    const addSBinLS = async (patientID , SB) => {
      const data = await getPreSignedData()
      const loggedUser = await getProviderDetails()
      const loggedUserID = loggedUser?.ID
      const userData = { ...(data[loggedUserID] || {}) }
      const patientData = { ...(userData[patientID] || {}) }
      const existingSB = patientData.patientSuperBill || []
      const newlyAddedData = patientData.newlyAddedData || []
      const newlyAddedSB = patientData?.newlyAddedData?.patientSuperBill || []

      console.log('orderAllDetials', existingSB, newlyAddedData, newlyAddedSB)
      const tempOrderId = Math.floor(100 + Math.random() * 900)
      const addSB = {
        Id: tempOrderId,
        JsonData : JSON.stringify(SB),
        PatientId : patientID
      
      }
  const updatedPatientData = {
    ...patientData,
    patientSuperBill: [...existingSB, addSB],
    newlyAddedData: { ...newlyAddedData, patientSuperBill: [...newlyAddedSB, addSB] },
  }

  const updatedUserData = {
    ...userData,
    [patientID]: updatedPatientData,
  }

  const updatedData = {
    ...data,
    [loggedUserID]: updatedUserData,
  }

  console.log('updatedDataSB', updatedData)

      // console.log('ordeer update in ls ', updatedData)
            savePreSignedData(updatedData)
           setPatientDBData(updatedPatientData)
    }
 
  


     const updateSBData = async (patientID, SB , SBID) => {
       const data = await getPreSignedData()
       const loggedUser = await getProviderDetails()
       const loggedUserID = loggedUser?.ID
       const userData = { ...(data[loggedUserID] || {}) }
       const patientData = { ...(userData[patientID] || {}) }
       const existingSB = patientData.patientSuperBill || []
       const newlyAddedData = patientData.newlyAddedData || []
       const newlyAddedSB = patientData?.newlyAddedData?.patientSuperBill || []

       console.log('orderAllDetials-->', newlyAddedData, newlyAddedSB)
       const updateSBData = {
         Id: SBID,
         JsonData : JSON.stringify(SB),
         PatientId : patientID,
         shouldUpdate: true,
       }

      //  const updateSB = existingSB.map((item) => {
      //    if (item.Id === SBID) {
      //      return updateSBData
      //    }
      //    return item
      //  })

      //  const updateNewlySB = newlyAddedSB.map((item) => {
      //    if (item.id === SBID) {
      //      return updateSBData
      //    }
      //    return item
      //  })

      //  console.log('updateSBData', updateSBData)
       const updatedPatientData = {
         ...patientData,
         patientSuperBill: [updateSBData],
         //  newlyAddedData: { ...newlyAddedData, patientSuperBill: updateNewlySB.length > 0 ? updateNewlySB : [...newlyAddedSB, updateNewlySB] },
         newlyAddedData: { ...newlyAddedData, patientSuperBill: [updateSBData] },
       }

       const updatedUserData = {
         ...userData,
         [patientID]: updatedPatientData,
       }

       const updatedData = {
         ...data,
         [loggedUserID]: updatedUserData,
       }

       console.log('ordeer update in ls ', updatedData)
               savePreSignedData(updatedData)

        setPatientDBData(updatedPatientData)
     }


      const updatePatientTodaysAppointment = async (ID) => {
      const getTodaysAppointment =  noteCallType === 'OpenChart' ? await getOpenChartAppointmentData() : await getAllTodaysAppointment()
      const parsedAppointment = JSON.parse(getTodaysAppointment)
      const filterAppointment = parsedAppointment.filter((item) => item.PatientID !== parseInt(ID))
      // await saveAllTodaysAppointment(JSON.stringify(filterAppointment))
      noteCallType === 'OpenChart' ?  await saveOpenChartAppointmentData(JSON.stringify(filterAppointment)) :  await saveAllTodaysAppointment(JSON.stringify(filterAppointment))


     
    }




      const addNoteSeenData = async (verifyFormData , patientID) => {

    const data = await getPreSignedData()
    const loggedUser = await getProviderDetails()
    const loggedUserID = loggedUser?.ID
    const userData = { ...(data[loggedUserID] || {}) }
    const patientData = { ...(userData[patientID] || {}) }
    const newlyAddedData = patientData.newlyAddedData || []
     let existingCurrentNote = newlyAddedData?.currentNote || {}


    console.log("patinent data for seen patient" , data , patientData , patientID)
 
  //  await  updatePatientTodaysAppointment(patientID)
 
    await updatePreSignedAppointment(patientID)
    const notSeenData = {
      verifyFormData,
      patientID
    }
 
    const updateNote = {
     ...existingCurrentNote,
     isNoteSigned: true
    }
 
    const updatedPatientData = {
      ...patientData,
      newlyAddedData: { ...newlyAddedData,  notSeenData , currentNote: updateNote},
    }

    const updatedUserData = {
      ...userData,
      [patientID]: updatedPatientData,
    }

    const updatedData = {
      ...data,
      [loggedUserID]: updatedUserData,
    }
 
     console.log("updatedData",updatedData)
      
        savePreSignedData(updatedData)
        await setPatientDBData(updatedPatientData)


  }



    const updatePreSignedAppointment = async (ID) => {
    const getTodaysAppointment = await getPreSignedAppointment()
    const parsedAppointment = JSON.parse(getTodaysAppointment)
    const filterAppointment = parsedAppointment.filter((item) => item.PatientID !== parseInt(ID))
      // setFilteredPatientData(filterAppointment)
    console.log("savePreSignedAppointment",savePreSignedAppointment,filterAppointment)
    // await saveAllTodaysAppointment(JSON.stringify(filterAppointment))
    // await savePreSignedAppointment(JSON.stringify(filterAppointment))
  
 
 
  }


     const addNoteDeatilsInLs = async (patientID) => {
        console.log("error--->",patientID)
     try {
         const data = await getPreSignedData()
    const loggedUser = await getProviderDetails()
    const loggedUserID = loggedUser?.ID
    const userData = { ...(data[loggedUserID] || {}) }
    const patientData = { ...(userData[patientID] || {}) }
    const newlyAddedData = patientData.newlyAddedData || []
    let existingCurrentNote = newlyAddedData?.currentNote || {}

    console.log('orderAllDetials', newlyAddedData)
    const updateTodaysApppointment = await updatePreSignedAppointment(patientID)
    const updateNote = {
     ...existingCurrentNote,
     isNoteSigned: true
    }

    const updatedPatientData = {
      ...patientData,
      //  currentNote: updateNote,
      newlyAddedData: { ...newlyAddedData, currentNote: updateNote },
    }

    const updatedUserData = {
      ...userData,
      [patientID]: updatedPatientData,
    }

    const updatedData = {
      ...data,
      [loggedUserID]: updatedUserData,
    }

    console.log('updatedDataSB', updatedData)

    // await saveOfflineData(updatedData)
    // noteCallType === 'OpenChart' ? await saveOpenChartOfflineData(updatedData) : await saveOfflineData(updatedData)
     await savePreSignedData(updatedData)
     await setPatientDBData(updatedPatientData)
     } catch (error) {
        console.log("error while adding in ls ", error)
     }
  }




       const handleSubmit = async () => {

            
           if(formData?.patientSeen !== false) {
             if (!validateForm()) return
           }
     
             

        let data = patientDBData?.newlyAddedData?.patientSuperBill
            console.log('datapatientDBData ', patientDBData)
         if (data?.length > 0) {
           data = data.map((item) => ({
             ...item,
             JsonData: item?.JsonData ? JSON.parse(item.JsonData) : {},
           }))
         }

         const findBillForThisNote = data?.find((item) => item?.JsonData?.noteID === noteID)

         const payload = {
           ...formData,
           noteID,
           modifier: formData?.modifier === 'Others' ? formData?.extraModifierOtherValue : formData?.modifier,
           extraModifierOtherValue: undefined,
           PDate: formData.PDate?.split('/').join('-'), // Convert date to YYYY-MM-DD format
         }
         delete payload?.extraModifierOtherValue

         if (findBillForThisNote) {
           toast.success('SuperBill Updated Successfully!', toastConfig)

              await updateSBData(viewPatientDetail.PatientID.toString(), payload, findBillForThisNote?.Id)
         
          //  await PatientSuperBillData('Update', '', JSON.stringify(payload), findBillForThisNote?.Id, viewPatientDetail.PatientID.toString())

          
            console.log("for--->",formData)
          
           if(formData?.patientSeen === false){
             addNoteSeenData( formData , viewPatientDetail.PatientID )
           }else{
              await updateScheduleDataWithPatientSeenType()
           }
           

           setIsSuperbillUpdateOrSubmitted((p) => !p)
           await getSuperbillForthisnote()
           await getAppointmentForThisPatientScheduled()
         } else {
           try {
            await addSBinLS(viewPatientDetail.PatientID.toString(), payload)
            //  await PatientSuperBillData('Insert', '', JSON.stringify(payload), '', viewPatientDetail.PatientID.toString())
             toast.success('SuperBill Submitted Successfully!', toastConfig)
             console.log("formdata", formData)
           if(formData?.patientSeen === false){
             addNoteSeenData( formData , viewPatientDetail.PatientID )
           }else{
              await updateScheduleDataWithPatientSeenType()
           }

             setIsSuperbillUpdateOrSubmitted((p) => !p)
           } catch (error) {
             toast.error('Error submitting data: ', toastConfig)
             console.log("error while submiting sb", error)
           }
           console.log('Submitted data:', formData)
           await getSuperbillForthisnote()
           await getAppointmentForThisPatientScheduled()
         }

         if(formData.patientSeen === false){
            //  await addNoteDeatilsInLs(viewPatientDetail.PatientID)
             setPatientModalVisible(false)
          
         } else { 
          setSignedButtonStatus(true)
         }
        setShowOrderModel(false)
       }



  // const handleSubmit = async () => { 


  //   let data = await PatientSuperBillData('Get_By_PatientId', '', '', '', viewPatientDetail.PatientID.toString())
  //   data = JSON.parse(data?.d)?.Data || []

  //   if (data.length > 0) {
  //     data = data.map((item) => ({
  //       ...item,
  //       JsonData: item?.JsonData ? JSON.parse(item.JsonData) : {},
  //     }))
  //   }

  //   const findBillForThisNote = data.find((item) => item?.JsonData?.noteID === noteID)

  //   const payload = {
  //     ...formData,
  //     noteID,
  //     modifier : formData?.modifier === 'Others' ? formData?.extraModifierOtherValue : formData?.modifier,
  //     extraModifierOtherValue : undefined,
  //     PDate: formData.PDate?.split('/').join('-'), // Convert date to YYYY-MM-DD format
  //   }
  //   delete payload?.extraModifierOtherValue;
  //   if (findBillForThisNote) {
  //     toast.success('SuperBill Updated Successfully!', toastConfig)

  //     await PatientSuperBillData('Update', '', JSON.stringify(payload), findBillForThisNote?.Id, viewPatientDetail.PatientID.toString())

  //     await updateScheduleDataWithPatientSeenType()

  //     setIsSuperbillUpdateOrSubmitted((p) => !p)
  //     await getSuperbillForthisnote()
  //     await getAppointmentForThisPatientScheduled()
  //   } else {
  //     try {
  //       await PatientSuperBillData('Insert', '', JSON.stringify(payload), '', viewPatientDetail.PatientID.toString())
  //       toast.success('SuperBill Submitted Successfully!', toastConfig)
  //       await updateScheduleDataWithPatientSeenType()

  //       setIsSuperbillUpdateOrSubmitted((p) => !p)
  //     } catch (error) {
  //       toast.error('Error submitting data: ', error.message)
  //     }
  //     console.log('Submitted data:', formData)
  //     await getSuperbillForthisnote()
  //     await getAppointmentForThisPatientScheduled()

  //   }
  // }

  const patientTypeOptions = [
    { label: 'Short Term', value: 'Short Term' },
    { label: 'Long Term', value: 'Long Term' },
  ]

  const followUpTimeOptions = [
    { label: '1 week', value: '1 week' },
    { label: '2 week', value: '2 week' },
    { label: '3 week', value: '3 week' },
    { label: '4 week', value: '4 week' },
    { label: '5 week', value: '5 week' },
  ]

  const cptOptions = [
    { label: '99233', value: '99233' },
    { label: '99232', value: '99232' },
  ]
  const modifierOptions = [
    { label: 'Hospice:GW', value: 'Hospice:GW' },
    { label: 'TeleMedicine', value: 'TeleMedicine' },
    { label: 'ICU', value : 'ICU'},
    {label : 'None' , value : 'None'},
     { label: 'Others', value: 'Others' },
  ]

  const getCPTCodeOptions = () => {
    if (viewPatientDetail?.Status === 'NewPatient') {
      if (facilityType === 'ALF' || facilityType === 'Memory Care') {
        return [
          { label: '99342', value: '99342' },
          { label: '99344', value: '99344' },
          { label: '99345', value: '99345' },
        ]
      } else if (facilityType === 'SNF') {
        return [
          { label: '99305', value: '99305' },
          { label: '99306', value: '99306' },
        ]
      } else if (facilityType === 'Acute Rehab' || facilityType === 'Kindered') {
        return [
          { label: '99222', value: '99222' },
          { label: '99223', value: '99223' },
        ]
      }
    } else {
      if (facilityType === 'ALF' || facilityType === 'Memory Care') {
        return [
          { label: '99347', value: '99347' },
          { label: '99348', value: '99348' },
          { label: '99349', value: '99349' },
        ]
      } else if (facilityType === 'SNF') {
        return [
          { label: '99308', value: '99308' },
          { label: '99309', value: '99309' },
          { label: '99310', value: '99310' },
        ]
      } else if (facilityType === 'Acute Rehab' || facilityType === 'Kindered') {
        return [
          { label: '99231', value: '99231' },
          { label: '99232', value: '99232' },
          { label: '99233', value: '99233' },
        ]
      }
    }
    return []
  }

 
  const getData = async () => {
    // let facilityDetails = await FacilityCRUD('SELECT', {})
   
    // facilityDetails = JSON.parse(facilityDetails.d)?.Data

    let facilityDetails =  await getFacilityData()
    let appointmentData =  patientDBData?.appointmentData

    let facilityType = facilityDetails?.filter((item) => item.Name === viewPatientDetail?.FacilityName)[0]
    console.log('facilityDetails', facilityDetails, facilityType , appointmentData , patientDBData)
    setFacilityType(facilityType?.Type || '')
    setFormData((prev) => ({
      ...prev,
      patientType: appointmentData?.term,
      facilityName: viewPatientDetail?.FacilityName,
      facilityType: facilityType?.Type,
      patientSeen:  superBillState === 'preNotSigned' ? false : true 
    }))
  }

  const getSuperBillData = async () => {
    // let data = await PatientSuperBillData('Get_By_PatientId', '', '', '', viewPatientDetail?.PatientID.toString())
        //  data = JSON.parse(data?.d)?.Data || []
    let data = patientDBData?.newlyAddedData?.patientSuperBill
    if (data) {
      data = data?.map((item) => {
        return {
          Id: item.Id,
          Data: JSON.parse(item?.JsonData),
        }
      })
    }
    console.log('SuperBill Data', data, showInModel)

    if (data?.length > 0 ) {
      setFormData(data[data.length - 1].Data || {})
    }

    setSuperBill(data)
     
  }

  useEffect(() => {
    const initialize = async () => {
      await getData()
        await getSuperBillData()

      const diagnosisCodes = patientDiagnosis?.map((item) => `${diagnosisCode[item]} - ${item}`).join(', ') || ''
      console.log('diagnosisCodes', diagnosisCodes)
      setFormData((prev) => ({
        ...prev,
        icdCodes: diagnosisCodes,
      }))
      setFormData((prev) => ({
        ...prev,
        PDate: new Date().toLocaleDateString('en-US'),
      }))
    }
    getCPTCodeOptions()
    initialize()
  }, [])

  const optionReasonPatientSeen = [
    { label: 'Discharged', value: 'Discharged' },
    { label: 'Patient not in facility', value: 'Patient not in facility' },
    { label: 'Other', value: 'Other' },
  ]


  const validateForm = () => {
    let temp = {}

    if (!formData.patientType) temp.patientType = 'Patient Type is required.'
    if (!formData.followUpTime) temp.followUpTime = 'Follow Up Time is required.'

    if (isMoreThanOneWeek && !formData.reason?.trim()) {
      temp.reason = 'Reason is required.'
    }

    if (!formData.cptCode) temp.cptCode = 'CPT Code is required.'
    // if (!formData.icdCodes) temp.icdCodes = 'ICD Code is required.'
    if (!formData.modifier) temp.modifier = 'Modifier is required.'

    if (formData.modifier === 'Others' && !formData.extraModifierOtherValue?.trim()) {
      temp.extraModifierOtherValue = 'Please provide additional modifier details.'
    }

    setErrors(temp)
    return Object.keys(temp).length === 0
  }


  return (
    <div
      className=" m-3 p-4"
      style={{
        backgroundColor: '#191919',
        borderRadius: '10px',
      }}
    >
      <CRow className="mb-3">
        <CCol md={2}>Date</CCol>
        <CCol className="text-white">{formData?.PDate}</CCol>
      </CRow>
      <CRow className="mb-3">
        <CCol md={2}>Facility Name</CCol>
        <CCol className="text-white">{formData?.facilityName}</CCol>
      </CRow>
      <CRow className="mb-3">
        <CCol md={2}>Facility Type</CCol>
        <CCol className="text-white">{formData?.facilityType}</CCol>
      </CRow>

      <CRow className="mb-3">
        <CCol md={2}>Patient Seen</CCol>
        <CCol className="text-white">
          <span Patient Seen>
            <CButton
              className="px-3"
              style={{
                borderRadius: '0px',
                border: 0,
                background: formData?.patientSeen ? '#4363F2' : 'unset',
                color: 'white',
                fontSize: '14px',
              }}
              onClick={() => {
                setFormData({ ...formData, patientSeen: true })
              }}
            >
              Yes
            </CButton>

            <CButton
              onClick={() => {
                setFormData({ ...formData, patientSeen: false })
              }}
              className="px-4"
              style={{
                borderRadius: '0px',
                border: 0,
                background: formData?.patientSeen === false ? '#4363F2' : 'unset',
                color: 'white',
                fontSize: '14px',
              }}
            >
              No
            </CButton>
          </span>
        </CCol>
      </CRow>

      {!formData?.patientSeen && (
        <>
          <CRow className="mb-3 align-items-center">
            <CCol md={2}>
              <CFormLabel>Select Reason</CFormLabel>
            </CCol>
            <CCol>
              <Select
                options={optionReasonPatientSeen}
                value={optionReasonPatientSeen.find((opt) => opt.label === formData.notSeenReason) || null}
                onChange={(val) => setFormData({ ...formData, notSeenReason: val.label })}
                placeholder="Select an option"
                styles={{
                  control: (base) => ({
                    ...base,
                    borderRadius: '8px',
                    boxShadow: 'none',
                    borderColor: '#6f6f6fff',
                    background: '#191919', // dark control
                    color: 'white',
                  }),
                  menu: (base) => ({
                    ...base,
                    backgroundColor: '#000000', // dark dropdown background
                    borderRadius: '8px',
                    overflow: 'hidden',
                  }),
                  option: (base, state) => ({
                    ...base,
                    color: 'white', // text white
                    backgroundColor: state.isFocused ? '#333333' : '#000000', // highlight on hover
                    cursor: 'pointer',
                    padding: '10px 12px',
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: 'white', // selected value text white
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: '#9ca3af', // gray placeholder
                  }),
                  dropdownIndicator: (base) => ({
                    ...base,
                    color: 'white', // white arrow icon
                  }),
                  indicatorSeparator: (base) => ({
                    ...base,
                    backgroundColor: '#444', // subtle divider
                  }),
                }}
              />
            </CCol>
          </CRow>
          {formData.notSeenReason === 'Other' && (
            <CRow className="mb-3 align-items-center">
              <CCol md={2}>
                <CFormLabel>Reason</CFormLabel>
              </CCol>
              <CCol>
                <CFormTextarea style={{ background: '#191919', border: '1px solid #464646ff', color: 'white' }} value={formData.customReason} placeholder="Other reasons" onChange={(e) => setFormData({ ...formData, customReason: e.target.value })} rows={3} />
              </CCol>
            </CRow>
          )}
        </>
      )}

      {formData?.patientSeen && (
        <>
       { formData?.facilityType === 'SNF' &&  <CRow className="mb-3 align-items-center">
            <CCol md={2}>
              <CFormLabel>Patient Type</CFormLabel>
            </CCol>
            <CCol md={7}>
              <Select
                options={patientTypeOptions}
                value={patientTypeOptions.find((opt) => opt.label === formData.patientType) || null}
                onChange={(val) => setFormData({ ...formData, patientType: val.label })}
                placeholder="Select an option"
                styles={{
                  control: (base) => ({
                    ...base,
                    borderRadius: '8px',
                    boxShadow: 'none',
                    borderColor: '#6f6f6fff',
                    background: '#191919', // dark control
                    color: 'white',
                  }),
                  menu: (base) => ({
                    ...base,
                    backgroundColor: '#000000', // dark dropdown background
                    borderRadius: '8px',
                    overflow: 'hidden',
                  }),
                  option: (base, state) => ({
                    ...base,
                    color: 'white', // text white
                    backgroundColor: state.isFocused ? '#333333' : '#000000', // highlight on hover
                    cursor: 'pointer',
                    padding: '10px 12px',
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: 'white', // selected value text white
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: '#9ca3af', // gray placeholder
                  }),
                  dropdownIndicator: (base) => ({
                    ...base,
                    color: 'white', // white arrow icon
                  }),
                  indicatorSeparator: (base) => ({
                    ...base,
                    backgroundColor: '#444', // subtle divider
                  }),
                }}
              />

              {errors.patientType && <p className="text-danger mt-1">{errors.patientType}</p>}
            </CCol>
          </CRow>}

          <CRow className="mb-3 align-items-center">
            <CCol md={2}>
              <CFormLabel>Follow Up Time</CFormLabel>
            </CCol>
            <CCol md={7}>
              <Select
                options={followUpTimeOptions}
                value={followUpTimeOptions.find((opt) => opt.label === formData.followUpTime) || null}
                onChange={(val) => setFormData({ ...formData, followUpTime: val.label })}
                placeholder="Select an option"
                styles={{
                  control: (base) => ({
                    ...base,
                    borderRadius: '8px',
                    boxShadow: 'none',
                    borderColor: '#6f6f6fff',
                    background: '#191919',
                    color: 'white',
                  }),
                  menu: (base) => ({
                    ...base,
                    backgroundColor: '#000000',
                    borderRadius: '8px',
                    overflow: 'hidden',
                  }),
                  option: (base, state) => ({
                    ...base,
                    color: 'white',
                    backgroundColor: state.isFocused ? '#333333' : '#000000',
                    cursor: 'pointer',
                    padding: '10px 12px',
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: 'white',
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: '#9ca3af',
                  }),
                  dropdownIndicator: (base) => ({
                    ...base,
                    color: 'white',
                  }),
                  indicatorSeparator: (base) => ({
                    ...base,
                    backgroundColor: '#444',
                  }),
                }}
              />
              {errors.followUpTime && <p className="text-danger mt-1">{errors.followUpTime}</p>}
            </CCol>
          </CRow>

          {isMoreThanOneWeek && (
            <CRow className="mb-3 align-items-center">
              <CCol md={2}>
                <CFormLabel>Reason</CFormLabel>
              </CCol>
              <CCol md={7}>
                <CFormTextarea style={{ background: '#191919', border: '1px solid #464646ff', color: 'white' }} value={formData.reason} placeholder="Provide the reason" onChange={(e) => setFormData({ ...formData, reason: e.target.value })} rows={3} />
                {errors.reason && <p className="text-danger mt-1">{errors.reason}</p>}
              </CCol>
            </CRow>
          )}

          <CRow className="mb-3  align-items-center">
            <CCol md={2} className="d-flex align-items-center gap-2">
              <CFormLabel className="d-flex gap-1 align-items-center">
                CPT Code
                <span onClick={() => setVisible(true)} className="text-dark ml-2 d-block" title="Info">
                  <Info size={17} />
                </span>
              </CFormLabel>
            </CCol>
            <CCol md={7}>
              <Select
                options={getCPTCodeOptions()}
                value={getCPTCodeOptions().find((opt) => opt.label === formData.cptCode) || null}
                onChange={(val) => setFormData({ ...formData, cptCode: val.label })}
                placeholder="Select an option"
                styles={{
                  control: (base) => ({
                    ...base,
                    borderRadius: '8px',
                    boxShadow: 'none',
                    borderColor: '#6f6f6fff',
                    background: '#191919',
                    color: 'white',
                  }),
                  menu: (base) => ({
                    ...base,
                    backgroundColor: '#000000',
                    borderRadius: '8px',
                    overflow: 'hidden',
                  }),
                  option: (base, state) => ({
                    ...base,
                    color: 'white',
                    backgroundColor: state.isFocused ? '#333333' : '#000000',
                    cursor: 'pointer',
                    padding: '10px 12px',
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: 'white',
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: '#9ca3af',
                  }),
                  dropdownIndicator: (base) => ({
                    ...base,
                    color: 'white',
                  }),
                  indicatorSeparator: (base) => ({
                    ...base,
                    backgroundColor: '#444',
                  }),
                }}
              />
              {errors.cptCode && <p className="text-danger mt-1">{errors.cptCode}</p>}
            </CCol>
          </CRow>

          <CRow className="mb-3">
            <CCol md={2}>ICD Code</CCol>
            <CCol md={7}>
              <CCardText className="p-2   rounded">{formData.icdCodes}</CCardText>
            </CCol>
          </CRow>

          <CRow className="mb-3 align-items-start">
            <CCol md={2}>
              <CFormLabel>Modifier</CFormLabel>
            </CCol>
            <CCol md={7}>
              <Select
                options={modifierOptions}
                value={modifierOptions.find((opt) => opt.label === formData.modifier) || null}
                onChange={(val) => setFormData({ ...formData, modifier: val.label })}
                placeholder="Select option"
                styles={{
                  control: (base) => ({
                    ...base,
                    borderRadius: '8px',
                    boxShadow: 'none',
                    borderColor: '#6f6f6fff',
                    background: '#191919',
                    color: 'white',
                  }),
                  menu: (base) => ({
                    ...base,
                    backgroundColor: '#000000',
                    borderRadius: '8px',
                    overflow: 'hidden',
                  }),
                  option: (base, state) => ({
                    ...base,
                    color: 'white',
                    backgroundColor: state.isFocused ? '#333333' : '#000000',
                    cursor: 'pointer',
                    padding: '10px 12px',
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: 'white',
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: '#9ca3af',
                  }),
                  dropdownIndicator: (base) => ({
                    ...base,
                    color: 'white',
                  }),
                  indicatorSeparator: (base) => ({
                    ...base,
                    backgroundColor: '#444',
                  }),
                }}
              />
              {formData?.modifier === 'Others' && (
                <div className="mt-2">
                  <CFormTextarea style={{ background: '#191919', border: '1px solid #464646ff', color: 'white' }} value={formData.extraModifierOtherValue} placeholder="Provide the reason" onChange={(e) => setFormData({ ...formData, extraModifierOtherValue: e.target.value })} rows={3} />
                </div>
              )}
              {errors.modifier && <p className="text-danger mt-1">{errors.modifier}</p>}
            </CCol>
          </CRow>

          <CRow className="mb-4">
            <CCol md={2}></CCol>
            <CCol>
              <CFormCheck className="custom-checkbox" label="Checked out with DON/ADON" checked={formData.checkedOut} onChange={(e) => setFormData({ ...formData, checkedOut: e.target.checked })} />
            </CCol>
          </CRow>
        </>
      )}

      {showInModel ? (
        <div className="d-flex justify-content-end gap-2">
          <CButton color="secondary" onClick={() => setShowSuperBill(false)} variant="outline">
            Close
          </CButton>
          <CButton
            style={{
              padding: '8px 26px',
              borderRadius: '8px',
              fontWeight: ' ',
              // boxShadow: '0 4px 10px rgba(0, 123, 255, 0.2)',
              background: '#4363F2',
            }}
            onClick={() => {
              handleSubmit(), setShowSuperBill(false)
            }}
            variant="outline"
          >
            Submit
          </CButton>
        </div>
      ) : (
        <div className="text-center mt-5">
          <CButton
            color="primary"
            onClick={handleSubmit}
            style={{
              padding: '8px 26px',
              borderRadius: '8px',
              fontWeight: ' ',
              // boxShadow: '0 4px 10px rgba(0, 123, 255, 0.2)',
              background: '#4363F2',
            }}
          >
            {Array.isArray(patientDBData?.newlyAddedData?.patientSuperBill) && patientDBData?.newlyAddedData?.patientSuperBill?.length > 0 ? "Update" : "Submit"}
          </CButton>
           <CButton
            color="secondary"
            onClick={()=>setShowOrderModel(false)}
             style={{
              padding: '8px 26px',
              borderRadius: '8px',
              fontWeight: ' ',
              // boxShadow: '0 4px 10px rgba(0, 123, 255, 0.2)',
            
              marginLeft:'10px'
            }}
          >
             Close
          </CButton>

        </div>
      )}

      <CModal size="lg" scrollable visible={visible} onClose={() => setVisible(false)}>
        <CModalHeader
          style={{
            backgroundColor: '#282828',
            borderBottom: '1px solid gray',
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
            borderRadius: '10px 10px 0 0',
          }}
          closeButton
        >
          <CModalTitle style={{ color: 'white', width: '100%', textAlign: 'center' }}>CPT Codes</CModalTitle>
        </CModalHeader>

        <CModalBody
          style={{
            backgroundColor: '#282828',
            color: 'white',
          }}
        >
          <div className="py-2">
            <h6
              style={{
                color: 'white',
              }}
            >
              Suggested Codes : SNF NEW PATIENT
            </h6>
            <p className="">
              <strong>99305:</strong>
              <br />
              1. No baseline. Minimal things we are doing. Cognitive stable with no other neuro issues. Do not use this code much as we have complex cases.
              <br />
              <br />
              <strong>99306:</strong>
              <br />
              • No baseline but we are managing complex neuro issues. Ex stroke, ams, falls or any neuro related issues etc. Majority will be these codes.
              <br />• Back office obtained baseline
            </p>

            <h6
              style={{
                color: 'white',
              }}
            >
              SNF FOLLOW UP
            </h6>
            <p>
              <strong>99308:</strong>
              <br />• SHORT TERM use this AFTER seeing patient 3-4 FOLLOW UPS since initial consult. Usually by this time patient is stable.
              <br />• Do not use this on LONG TERM as we see patient monthly and we state we reviewed all available records since last visit and spoke to nursing.
              <br />
              <br />
              <strong>99309:</strong>
              <br />• First 3-4 follow up visits
              <br />• Actively managing a new issue or existing after the first 4 follow ups.
              <br />• Use code if you spoke to family and document what you talked about. <br />• Use if nursing asked you to see and document nursing reason for us to see. <br />• Use on all long term patients we see monthly. State we reviewed all available records since last visit and spoke to
              nursing.
              <br />
              <br />
              <strong>99310:</strong>
              <br />
              1. Back office obtained baseline. Talk about the baseline in specific assessment.
              <br />• Make sure your subject states you spoke to nursing. Do not write staff, be specific. Change all assessments. If baseline added, please state you reviewed it in assessment and point out any issues found in baseline within the specific treatment assessment.
            </p>

            {/* 🔄 Repeat similar structure for all other sections */}
            <h6
              style={{
                color: 'white',
              }}
            >
              Suggested Codes: Acute Rehab, Kindred
            </h6>
            <p>
              <strong>HOSPITAL NEW PATIENT</strong>
              <br />
              <strong>99222:</strong>• No baseline. Minimal things we are doing. Do not use this code much as we have complex cases. Ex would be if a patient had a stroke over a year ago and has deficits and we got consulted to maintain management.
              <br />• No baseline and patient appears to be improving despite having a stroke. Stroke patients' deficits very minimal. Cognitively stable.
              <br />
              <br />
              <strong>99223:</strong>• No baseline but we are managing complex neuro issues where patient is not stable and has chance to decline. Ex stroke, ams, falls, history of dementia or any neuro related issues etc. Majority will be these codes.
              <br />• Back office obtained baseline
              <br />• You spoke to family and documented this in HPI
            </p>

            <h6
              style={{
                color: 'white',
              }}
            >
              HOSPITAL FOLLOW UP
            </h6>
            <p>
              <strong>99231:</strong>
              <br />
              1. Use this AFTER seeing patient 4-5 FOLLOW UPS since initial consult. Usually by this time patient is stable.
              <br />
              <br />
              <strong>99232:</strong>• First 4-5 follow up visits
              <br />• Actively managing a new issue or existing after the first 4-5 follow ups.
              <br />• Use code if you spoke to family and document what you talked about. <br />• Use if nursing asked you to see and document nursing reason for us to see.
              <br />
              <br />
              <strong>99233:</strong>
              <br />
              1. Back office obtained baseline. Talk about the baseline in specific assessment.
              <br />• Make sure your subject states you spoke to nursing. Do not write staff, be specific. Change all assessments. If baseline added, please state you reviewed it in assessment and point out any issues found in baseline within the specific treatment assessment.
            </p>

            {/* ... repeat the other sections like AIF, Memory Care, etc. */}
          </div>
        </CModalBody>

        <CModalFooter
          style={{
            backgroundColor: '#282828',
            borderTop: '1px solid gray',
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            padding: '10px',
            borderRadius: '0 0 10px 10px',
          }}
        >
          <CButton color="secondary" onClick={() => setVisible(false)}>
            Close
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  )
}

export default ProviderSuperbill
